import { Injectable } from '@angular/core';
import { gsap } from 'gsap';

@Injectable({ providedIn: 'root' })
export class PageTransitionService {
  fadeIn(element: HTMLElement) {
    gsap.fromTo(element, { opacity: 0 }, { opacity: 1, duration: 0.5 });
  }

  fadeOut(element: HTMLElement, onComplete?: () => void) {
    gsap.to(element, { opacity: 0, duration: 0.5, onComplete });
  }
}
